import { g2Reader } from './products/g2Reader.mjs';
import { g2ReaderPro } from './products/g2ReaderPro.mjs';
import { g3Intercom } from './products/g3Intercom.mjs';
import { g3Reader } from './products/g3Reader.mjs';
import { g3ReaderFlex } from './products/g3ReaderFlex.mjs';
import { g3ReaderPro } from './products/g3ReaderPro.mjs';
import { intercom } from './products/intercom.mjs';
import { readerAccessUltra } from './products/readerAccessUltra.mjs';
import './properties/index.mjs';
import { dimensions } from './properties/dimensions.mjs';
import { cameraReader } from './properties/cameraReader.mjs';
import { twoWayIntercom } from './properties/twoWayIntercom.mjs';
import { directory } from './properties/directory.mjs';
import { touchPassSupport } from './properties/touchPassSupport.mjs';
import { pinAccess } from './properties/pinAccess.mjs';
import { nfcCard } from './properties/nfcCard.mjs';
import { mobileAppAccess } from './properties/mobileAppAccess.mjs';
import { hand } from './properties/hand.mjs';
import { outdoorReady } from './properties/outdoorReady.mjs';
import { readerPowerMethod } from './properties/readerPowerMethod.mjs';
"use strict";
const Readers = {
  properties: [dimensions, cameraReader, twoWayIntercom, directory, touchPassSupport, pinAccess, nfcCard, mobileAppAccess, hand, outdoorReady, readerPowerMethod],
  products: [g3ReaderPro, g3ReaderFlex, g3Reader, g3Intercom, intercom, readerAccessUltra, g2ReaderPro, g2Reader],
  columnWidth: 260,
  propertyColumnWidth: 210,
  showBadges: true
};
export { Readers };
//# sourceMappingURL=Readers.mjs.map
